import { FETCH_EXEMPTED_POLICY_BUNDLES_SUCCESS } from './exemptedPolicyBundles-actions';

const initialState = {
    list: [],
    first: true,
    last: false,
    forwardSeekMap: null,
    backwardSeekMap: null,
    page: null,
    size: 10,
};

const exemptedPolicyBundlesReducer = (state = initialState, action) => {
    switch (action.type) {
    case FETCH_EXEMPTED_POLICY_BUNDLES_SUCCESS:
        return {
            ...state,
            list: action.data.content,
            first: action.data.first,
            last: action.data.last,
            forwardSeekMap: action.data.forwardSeekMap,
            backwardSeekMap: action.data.backwardSeekMap,
            page: action.data.page,
            size: action.data.size,
            seekParams: action.seekParams,
        };

    default:
        return state;
    }
};

export default exemptedPolicyBundlesReducer;
